import styled from 'styled-components';

import SVGIcon from 'src/components/ui/SVGIcon';
import ThemedLogo from 'src/components/ui/ThemedLogo';

const HeaderWrapper = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 24px 40px;
    background-color: var(--header-background);
`;

const HeaderNavigationBar = styled.div`
    display: flex;
`;

const HeaderNavigationAnchor = styled.a`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 16px;
    white-space: nowrap;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-decoration: none;
    color: var(--header-text);

    &:hover {
        color: var(--poki-blue);
    }
`;

const HeaderLogo = styled(ThemedLogo)`
    width: 144px;
`;

const StyledHeaderNavigationSVGIcon = styled(SVGIcon)`
    width: 18px;
    height: 18px;
`;

const MENU_ITEMS = [
    {
        title: 'Developer Guide',
        to: 'https://developers.poki.com/guide',
        icon: <StyledHeaderNavigationSVGIcon icon="document" />,
    },
    {
        title: 'Poki SDK',
        to: 'https://sdk.poki.com/',
        icon: <StyledHeaderNavigationSVGIcon icon="code" />,
    },
    {
        title: 'Sign In',
        to: 'https://app.poki.dev/signin',
        icon: <StyledHeaderNavigationSVGIcon icon="login" />,
    },
];

export default function Header() {
    return (
        <HeaderWrapper>
            <HeaderNavigationAnchor href="/">
                <HeaderLogo alt="Poki for Developers - Beta" />
            </HeaderNavigationAnchor>
            <HeaderNavigationBar>
                {MENU_ITEMS.map((item) => (
                    <HeaderNavigationAnchor key={item.to} href={item.to} target="_blank">
                        {item.icon}
                        {item.title}
                    </HeaderNavigationAnchor>
                ))}
            </HeaderNavigationBar>
        </HeaderWrapper>
    );
}
